export const CREATE_RETURN_LABEL_MODAL_FORM = 'CREATE_RETURN_LABEL_MODAL_FORM'

export const NEW_RETURN_FLOW_URL = 'https://newreturnflow.everphone.app'

// Generic everphone return-label form used whenever the organisation has no
// dedicated fulfillment-provider URL for the selected country. Placeholders are
// filled by `replaceUrlPlaceholders` in CreateReturnLabel.utils.
export const FALLBACK_RETURN_LABEL_FORM_URL =
  'https://services.everphone.app/form/4ac4080c-8c06-40fe-9874-a0ddacc3b0bd?Return-Case-ID={{RETURN_CASE_ID}}&IMEI-or-SN={{IMEI_OR_SERIAL}}'
